"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8460],{

/***/ 92578:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var Heading = function(props) {
    var ref;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
        className: "Heading",
        children: props === null || props === void 0 ? void 0 : (ref = props.headingData) === null || ref === void 0 ? void 0 : ref.text
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Heading);


/***/ }),

/***/ 71892:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ModernMiddleBody1; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/CommonComponents/Heading/Heading.js
var Heading = __webpack_require__(92578);
// EXTERNAL MODULE: ./src/components/WidgetMaker/utils/common.ts
var common = __webpack_require__(37179);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/utils/getStylesConfig.js
var getStylesConfig = __webpack_require__(42757);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/utils/common.js + 8 modules
var utils_common = __webpack_require__(77297);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(26601);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/MiddleBody/MiddleBody_Gallery/ModernMiddleBody1/ModernMiddleBody1.styled.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  background-size: cover;\n  background-position: center;\n  flex-direction: column;\n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 0; /* Set the z-index behind other content */\n  }\n  /* Add a linear gradient overlay */\n  &::after {\n    content: '';\n    background: ",
        ";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 1;\n    opacity: ",
        ";\n  }\n  @media screen and (min-width: 768px) {\n    & > video {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      object-fit: cover; /* Scale the video while maintaining its aspect ratio */\n    }\n  }\n  @media screen and (max-width: 767px) {\n    & > video {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      object-fit: cover; /* Scale the video while maintaining its aspect ratio */\n    }\n  }\n\n  & > video {\n    position: absolute;\n    height: 100%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  z-index: 3;\n  flex-direction: column;\n  &.bg_type_image {\n    background: ",
        ";\n    background-size: cover;\n    background-position: center;\n  }\n  &.bg_type_solid {\n    background: ",
        ";\n  }\n  @media screen and (min-width: 768px) {\n    gap: 4rem;\n    padding: 4rem 0rem;\n  }\n  @media screen and (max-width: 767px) {\n    gap: 1.5rem;\n    padding: 2rem 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n\n  @media screen and (min-width: 768px) {\n    gap: 4rem;\n    padding: 0 4rem;\n  }\n  @media screen and (max-width: 767px) {\n    gap: 0;\n    padding: 0 1rem;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1 0 auto;\n  width: 100%;\n  & > h1 {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    width: 100%;\n    margin: 0;\n    color: ",
        ";\n    font-family: ",
        ";\n    text-align: ",
        ";\n  }\n\n  @media screen and (min-width: 768px) {\n    & > h1 {\n      font-size: ",
        ";\n      font-weight: ",
        ";\n      line-height: 3.875rem;\n    }\n  }\n  @media screen and (max-width: 767px) {\n    & > h1 {\n      font-size: 1.5rem;\n      font-weight: 700;\n      line-height: normal;\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 0;\n  width: 0;\n  @media screen and (max-width: 767px) {\n    display: none;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .slider__parent {\n    display: block;\n    width: 100%;\n    height: auto !important;\n  }\n  .slick-list {\n    height: auto !important;\n  }\n  .slider__parent .slick-slider .slick-list .slick-track .slick-slide {\n    padding-right: 1rem;\n  }\n  .slider__parent .slick-slider .slick-list .slick-track .slick-slide div {\n    aspect-ratio: 3/4 !important;\n  }\n  .slider__parent .slick-slider .slick-list .slick-track .slick-slide div .slider-media {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    justify-content: center;\n    .slide-image-container {\n      max-width: 100%;\n      max-height: 100%; /* Adjust this value as needed for your aspect ratio */\n      position: relative;\n      img {\n        margin: auto 1rem 0rem 0rem;\n        max-width: 100%;\n        max-height: 100%;\n        width: 100%;\n        aspect-ratio: 3/4;\n      }\n\n      p {\n        height: 20px;\n        line-height: 24px;\n        color: ",
        ";\n        text-align: ",
        ";\n        font-family: ",
        ";\n        font-size: ",
        ";\n        font-weight: ",
        ";\n      }\n\n      @media screen and (max-width: 767px) {\n        p {\n          font-size: 1rem;\n        }\n      }\n    }\n  }\n  .slider__parent .slick-slider ul {\n    display: none !important;\n  }\n  .slider__parent .arrow-group {\n    display: flex;\n    gap: 1rem;\n    width: 100%;\n    justify-content: flex-end;\n    position: absolute;\n    top: 86px;\n    right: 43px;\n    color: white;\n  }\n  .slider__parent .arrow-group button {\n    color: white;\n    cursor: pointer;\n  }\n  .slider__parent .arrow-group button svg path {\n    fill: currentColor;\n  }\n  .slider__parent .slick-slider ul {\n    display: none !important;\n  }\n  @media screen and (min-width: 768px) {\n    padding-left: 4rem;\n  } //\n  @media screen and (max-width: 767px) {\n    padding-left: 1rem;\n    .slider__parent .arrow-group {\n      display: none !important;\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var MiddleBodyVideoBackground = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject(), function(props) {
    var ref, ref1;
    return !((ref1 = props === null || props === void 0 ? void 0 : (ref = props.propsBackground) === null || ref === void 0 ? void 0 : ref.content[0]) === null || ref1 === void 0 ? void 0 : ref1.url) && "none, ".concat(props === null || props === void 0 ? void 0 : props.themeBackground);
}, function(props) {
    return props === null || props === void 0 ? void 0 : props.themeBackground;
}, utils_common/* BANNER_OPACITY */.Gx);
var MiddleBodyParent = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject1(), function(props) {
    var ref, ref1, ref2, ref3;
    return ((ref1 = props === null || props === void 0 ? void 0 : (ref = props.propsBackground) === null || ref === void 0 ? void 0 : ref.content[0]) === null || ref1 === void 0 ? void 0 : ref1.url) ? "url(".concat((ref3 = props === null || props === void 0 ? void 0 : (ref2 = props.propsBackground) === null || ref2 === void 0 ? void 0 : ref2.content[0]) === null || ref3 === void 0 ? void 0 : ref3.url, ")") : "none, ".concat(props === null || props === void 0 ? void 0 : props.themeBackground);
}, function(props) {
    return props === null || props === void 0 ? void 0 : props.themeBackground;
});
var TopSection = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject2());
var TopLeftSection = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject3(), function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.color;
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.fontFamily) || "Arial";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.textAlign) || "left";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.fontSize) || "3.25rem";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.heading) === null || ref1 === void 0 ? void 0 : ref1.fontWeight) || "500";
});
var TopRightSection = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject4());
var BottomSection = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject5(), function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.color;
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.textAlign) || "center";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontFamily) || "Arial";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontSize) || "1.125rem";
}, function(props) {
    var ref, ref1;
    return (props === null || props === void 0 ? void 0 : (ref = props.textStyles) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.fontWeight) || "400";
});

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts
var ssrStore = __webpack_require__(20155);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/MiddleBody/MiddleBody_Gallery/ModernMiddleBody1/ModernMiddleBody1.js











function ModernMiddleBody10(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
    var ref16 = (0,react.useState)((0,common/* transformWidgetProps */.Ak)(props === null || props === void 0 ? void 0 : (ref = props.config) === null || ref === void 0 ? void 0 : ref.children)), middleBodyState = ref16[0], setMiddleBodyState = ref16[1];
    var ref17 = (0,react.useState)({
        config: {
            bannerAspectRatio: {
                desktop: 768,
                mobile: 768
            },
            rotationSpeed: 3
        }
    }), styleConfig = ref17[0];
    var storeData = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            storeData: state.storeReducer.store
        };
    }).storeData;
    var widgetData = (0,es/* useSelector */.v9)(function(state) {
        return {
            widgetData: state.widgetsReducer
        };
    }).widgetData;
    var ref18 = (0,react.useState)(storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.theme) === null || ref1 === void 0 ? void 0 : ref1.style_template), propStyle = ref18[0], setPropStyle = ref18[1];
    (0,react.useEffect)(function() {
        var ref;
        if (props === null || props === void 0 ? void 0 : (ref = props.config) === null || ref === void 0 ? void 0 : ref.children) {
            var ref1;
            setMiddleBodyState((0,common/* transformWidgetProps */.Ak)(props === null || props === void 0 ? void 0 : (ref1 = props.config) === null || ref1 === void 0 ? void 0 : ref1.children));
        }
    }, [
        props === null || props === void 0 ? void 0 : (ref2 = props.config) === null || ref2 === void 0 ? void 0 : ref2.children
    ]);
    (0,react.useEffect)(function() {
        if (widgetData === null || widgetData === void 0 ? void 0 : widgetData.activeStyleTemplate) {
            setPropStyle((0,getStylesConfig/* getStyleForProps */.dn)(widgetData === null || widgetData === void 0 ? void 0 : widgetData.activeStyleTemplate));
        } else {
            var ref;
            setPropStyle((0,getStylesConfig/* getStyleForProps */.dn)(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : ref.style_template));
        }
    }, [
        widgetData === null || widgetData === void 0 ? void 0 : widgetData.activeStyleTemplate,
        storeData === null || storeData === void 0 ? void 0 : (ref3 = storeData.theme) === null || ref3 === void 0 ? void 0 : ref3.style_template
    ]);
    (0,react.useEffect)(function() {
        var video = document.querySelector("video");
        if (video) {
            video.setAttribute("playsinline", "");
        }
    }, []);
    var renderParentContainer = function(bgType) {
        var ref, ref1, ref2, ref3;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopSection, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TopLeftSection, {
                            styleConfig: {
                                config: (0,_object_spread/* default */.Z)({}, middleBodyState === null || middleBodyState === void 0 ? void 0 : middleBodyState.config),
                                contentStyle: {
                                    heading: middleBodyState === null || middleBodyState === void 0 ? void 0 : middleBodyState.heading
                                }
                            },
                            textStyles: propStyle,
                            children: (middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref = middleBodyState.heading) === null || ref === void 0 ? void 0 : ref.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                headingData: middleBodyState === null || middleBodyState === void 0 ? void 0 : middleBodyState.heading
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TopRightSection, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomSection, {
                    textStyles: propStyle,
                    children: (0,utils_common/* renderMediaComponent */.CB)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        id: middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref1 = middleBodyState.media) === null || ref1 === void 0 ? void 0 : ref1.id
                    }, middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref2 = middleBodyState.media) === null || ref2 === void 0 ? void 0 : ref2.foreground), {
                        usedIn: "gallery",
                        arrowColor: propStyle === null || propStyle === void 0 ? void 0 : (ref3 = propStyle.heading) === null || ref3 === void 0 ? void 0 : ref3.color
                    }))
                })
            ]
        });
    };
    return (middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref4 = middleBodyState.background) === null || ref4 === void 0 ? void 0 : ref4.type) === "video" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(MiddleBodyVideoBackground, {
        id: "MT__MIDDLEBODY_GALLERY_MB1",
        styleConfig: styleConfig === null || styleConfig === void 0 ? void 0 : styleConfig.config,
        themeBackground: propStyle === null || propStyle === void 0 ? void 0 : propStyle.backgroundColor,
        className: "modern_theme_middlebody_gallery1 bg_type_".concat(middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref5 = middleBodyState.media) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.background) === null || ref6 === void 0 ? void 0 : ref6.type),
        children: [
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                autoPlay: true,
                loop: true,
                muted: true,
                playsInline: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                    src: (ref9 = middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref7 = middleBodyState.media) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.background) === null || ref8 === void 0 ? void 0 : ref8.content[0]) === null || ref9 === void 0 ? void 0 : ref9.url,
                    type: "video/mp4"
                })
            }),
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MiddleBodyParent, {
                id: "MT__MiddleBody_Gallery_MB1",
                styleConfig: styleConfig === null || styleConfig === void 0 ? void 0 : styleConfig.config,
                propsBackground: middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref10 = middleBodyState.media) === null || ref10 === void 0 ? void 0 : ref10.background,
                themeBackground: propStyle === null || propStyle === void 0 ? void 0 : propStyle.backgroundColor,
                className: "modern_theme_middlebody_gallery1 bg_type_".concat(middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref11 = middleBodyState.media) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.background) === null || ref12 === void 0 ? void 0 : ref12.type),
                children: renderParentContainer("video")
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(MiddleBodyParent, {
        id: "MT__MiddleBody_Gallery_MB1",
        styleConfig: styleConfig === null || styleConfig === void 0 ? void 0 : styleConfig.config,
        propsBackground: middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref13 = middleBodyState.media) === null || ref13 === void 0 ? void 0 : ref13.background,
        themeBackground: propStyle === null || propStyle === void 0 ? void 0 : propStyle.backgroundColor,
        className: "modern_theme_middlebody_gallery1 bg_type_".concat(middleBodyState === null || middleBodyState === void 0 ? void 0 : (ref14 = middleBodyState.media) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.background) === null || ref15 === void 0 ? void 0 : ref15.type),
        children: renderParentContainer("image")
    });
}
/* harmony default export */ var ModernMiddleBody1 = (ModernMiddleBody10);


/***/ })

}]);